import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const NoteIcon = (props: SvgProps) => <Svg
  width='16'
  height='16'
  viewBox='0 0 16 16'
  fill='none'
  {...props}
>
  <Path
    d='M9.33398 12.6667C11.848 12.6667 13.1053 12.6667 13.886 11.8853C14.6673 11.1047 14.6673 9.84733 14.6673 7.33333C14.6673 4.81933 14.6673 3.562 13.886 2.78133C13.1053 2 11.848 2 9.33398 2H6.66732C4.15332 2 2.89598 2 2.11532 2.78133C1.33398 3.562 1.33398 4.81933 1.33398 7.33333C1.33398 9.84733 1.33398 11.1047 2.11532 11.8853C2.55065 12.3213 3.13398 12.514 4.00065 12.5987'
    stroke={props.color ?? '#3379BD'}
    strokeLinecap='round'
    strokeLinejoin='round'
  />
  <Path
    d='M9.33349 12.666C8.50949 12.666 7.60149 12.9993 6.77283 13.4293C5.44083 14.1207 4.77483 14.4667 4.44683 14.246C4.11883 14.026 4.18083 13.3427 4.30549 11.9767L4.33349 11.666'
    stroke={props.color ?? '#3379BD'}
    strokeLinecap='round'
  />
  <Path
    d='M12.0006 4.66603C11.1766 4.66603 10.6673 4.66604 9.6673 4.66603C8.00063 4.66604 3.33398 4.66602 3.33398 4.66602L6.00063 4.66605'
    stroke={props.color ?? '#3379BD'}
    strokeLinecap='square'
  />
  <Path
    d='M12.0006 7.334C11.1766 7.334 10.6673 7.33401 9.6673 7.334C8.00063 7.33401 3.33398 7.33398 3.33398 7.33398L6.00063 7.33402'
    stroke={props.color ?? '#3379BD'}
    strokeLinecap='square'
  />
  <Path
    d='M12.0006 10C11.1766 10 10.6673 10 9.6673 10C8.00063 10 3.33398 10 3.33398 10L6.00063 10'
    stroke={props.color ?? '#3379BD'}
    strokeLinecap='square'
  />
</Svg>;

export default NoteIcon;
